import React from "react";
import { FormFieldDataSource } from "containers/Settings/RuleBooks/types";
import { FeeOperator } from "containers/Settings/RuleBooks/constants";
import { RoundingMethod } from "containers/Settings/RuleBooks/lib";
import { SchemaFieldDataSourceField } from "containers/Settings/RuleBooks/DataSource/SchemaFieldDataSource";
import { ConstantDataSourceField } from "containers/Settings/RuleBooks/DataSource/ConstantDataSource";
import { ValueClause } from "./ValueClause";

type EnabledDataSource = ConstantDataSourceField | SchemaFieldDataSourceField;

interface Fee {
  // Whether to subtract the Fees value from the input source or not
  apportionFromSource: boolean;

  // A DataSource that determines whether the Fee is enabled or not
  enabledQuery: EnabledDataSource;
  // The name of the Fee e.g. GST
  name: string;

  // The operation to perform on the Fee value
  operation: ValueInObj<typeof FeeOperator>;
  operationInput: {
    source: "CONSTANT";
    value: number;
  };
}

export interface ValueFormValues {
  // Base Price
  value: {
    amount: FormFieldDataSource; // The amount to be used in the calculation
    units: FormFieldDataSource; // The units to be used in the calculation
    offset: FormFieldDataSource; // The offset to be used in the calculation
    unit_offset: FormFieldDataSource; // The unit offset to be used in the calculation
    unit_limit: FormFieldDataSource; // The unit limit to be used in the calculation
    rounding_strategy: ValueInObj<typeof RoundingMethod>; // The rounding strategy to be used in the calculation
    rounding_value: number; // The rounding value to be used in the calculation
    output_as_single_unit: boolean; // Whether to output convert the total price to a single unit of 1 * total price
  };

  multiplier: number;

  // Fees
  fees: Fee[];
}

interface ValueFormProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Rule criteria object from schema
  criteria: any;
  isMasterRule: boolean;
  parentInputPath: string | null;
  ruleInputPath: string | null;
  showPrerequisiteRuleSource: boolean;
  namespace?: string;
}

export function ValueForm(props: ValueFormProps) {
  const {
    criteria,
    isMasterRule,
    namespace: ns = "",
    parentInputPath,
    ruleInputPath,
    showPrerequisiteRuleSource,
  } = props;
  return (
    <ValueClause
      criteria={criteria}
      namespace={ns}
      parentInputPath={parentInputPath}
      ruleInputPath={ruleInputPath}
      showPrerequisiteRuleSource={showPrerequisiteRuleSource}
      isMasterRule={isMasterRule}
    />
  );
}
